import { addMigration } from "./all";

addMigration({
  "ka²³wi² a¹¹gwa²du²²li³": "ka²³wi² a¹¹gwa²du²²li³ha²",
  "do² u⁴⁴sdi, ha²su²²yv¹¹ʔa²": "do² u⁴⁴sdi, ha²su²²yv¹¹ga²",
  "di²²sgi²di³²si, ha²ye²²la,sdi²": "ha²ye²²la,sdi² di²²sgi²di³²si,",
});
